"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isArray = (function () { return Array.isArray || (function (x) { return x && typeof x.length === 'number'; }); })();
//# sourceMappingURL=isArray.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs/internal/util/isArray.js
// module id = 5625
// module chunks = 0